import React from 'react';
import {z} from "zod";
import {useForm} from "react-hook-form";
import {zodResolver} from "@hookform/resolvers/zod";
import FiltersForm from "@/components/filtersForm/FiltersForm";
import {FormControl, FormField, FormItem, FormMessage} from "@/components/ui/form";
import {Button} from "@/components/ui/button";
import {Input} from "@/components/ui/input";
import {Select, SelectContent, SelectItem, SelectTrigger, SelectValue} from "@/components/ui/select";
import {IconSearch} from "@tabler/icons-react";

const FiltersFormRecherche = ({thematiques, contextQuery}) => {

  const search = contextQuery.search || '';
  const thematique = contextQuery.thematique || '';
  const page = contextQuery.page || '';

  const formSchema = z.object({
    search: z.string().optional(),
    thematique: z.string().optional(),
    page: z.string().optional(),
  })

  const form = useForm<z.infer<typeof formSchema>>({
    resolver: zodResolver(formSchema),
    defaultValues: {
      search,
      thematique,
      page
    },
  })

  return (
    <FiltersForm form={form} formSchema={formSchema} className='flex grid md:grid-cols-6 w-full gap-3 my-8'>
      <FormField
        control={form.control}
        name="search"
        render={({field}) => (
          <FormItem className='md:col-span-3'>
            <FormControl>
              <Input placeholder="Rechercher" icon={<IconSearch className="text-accent-foreground"/>} {...field} />
            </FormControl>
            <FormMessage/>
          </FormItem>
        )}
      />

      <FormField
        control={form.control}
        name="thematique"
        render={({field}) => (
          <FormItem className='md:col-span-2'>
            <Select onValueChange={field.onChange} defaultValue={field.value}>
              <FormControl>
                <SelectTrigger>
                  <SelectValue placeholder="Thématiques"/>
                </SelectTrigger>
              </FormControl>
              <SelectContent>
                <SelectItem key={`thematique-all`} value='all'>Toutes les thématiques</SelectItem>
                {thematiques.map((thematique) => (
                  <SelectItem key={`thematique-${thematique.drupal_internal__tid}`} value={thematique.drupal_internal__tid.toString()}>{thematique.name}</SelectItem>
                ))}
              </SelectContent>
            </Select>
            <FormMessage/>
          </FormItem>
        )}
      />
      <Button type='submit'>Rechercher</Button>
    </FiltersForm>
  );
};

export default FiltersFormRecherche;
